// Pull the display URLs off a Shopify REST product (product.images[].src).
// Shared by the Edit modal photo strip (F1) and the identify picker (F2).
export function shopifyImageUrls(product) {
  const images = product?.images
  if (!Array.isArray(images)) return []
  return images.map(img => img?.src).filter(src => typeof src === 'string' && src.length > 0)
}
